export const usageSummary = (state) => state.usage.summary;
export const usageSummaryError = (state) => state.usage.summaryError;
export const usageDaily = (state) => state.usage.daily;
export const usageDailyError = (state) => state.usage.dailyError;
export const usageWorkflows = (state) => state.usage.workflows;
export const usageWorkflowsError = (state) => state.usage.workflowsError;
export const usageWorkflowSeries = (state) => state.usage.workflowSeries;
export const usageWorkflowSearch = (state) => state.usage.workflowSearch;
export const usageInstallations = (state) => state.usage.installations;
export const usageInstallationsError = (state) => state.usage.installationsError;
export const usageInstallationDetailById = (state) => state.usage.installationDetailById;
export const usageInstallationDetailError = (state) => state.usage.installationDetailError;
export const usageCoverage = (state) => state.usage.coverage;
